import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'tabulator-tables/dist/css/tabulator.min.css'
//import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/functions'
import 'firebaseui/dist/firebaseui.css'
import firebaseui from 'firebaseui'
import MultiFiltersPlugin from './plugins/MultiFilters'

Vue.config.productionTip = false

Vue.use(MultiFiltersPlugin);

// configuration for nenc mentor app project
var nencConfig = {
  apiKey: "AIzaSyCTqn38Srz3BkpF7OYq92ZoFwyr5PtO_Jc",
  authDomain: "nenc-mentors.firebaseapp.com",
  databaseURL: "https://nenc-mentors.firebaseio.com",
  projectId: "nenc-mentors",
  storageBucket: "nenc-mentors.appspot.com",
  messagingSenderId: "732020080226"
};

// configuration for south-east mentor app project
var seConfig = {
  apiKey: "AIzaSyAkOhS3LYwqAOQ8qC23uCvVoWFAttuYG_M",
  authDomain: "southeast-mentors.firebaseapp.com",
  databaseURL: "https://southeast-mentors.firebaseio.com",
  projectId: "southeast-mentors",
  storageBucket: "southeast-mentors.appspot.com",
  messagingSenderId: "560591239126",
  appId: "1:560591239126:web:c521b8d727d07340f19677",
  measurementId: "G-HZQ5W3BJCV"
};

// configuration for yorkshumber mentor app project
var yhConfig = {
  apiKey: "AIzaSyDznP9A0GAwPkDy1Yber73YUBKPIE48Q2M",
  authDomain: "yorkshumber-mentors.firebaseapp.com",
  databaseURL: "https://yorkshumber-mentors.firebaseio.com",
  projectId: "yorkshumber-mentors",
  storageBucket: "yorkshumber-mentors.appspot.com",
  messagingSenderId: "941620290503",
  appId: "1:941620290503:web:5786c07474f50f6333afe2"
};

// Your web app's Firebase configuration
var devConfig = {
  apiKey: "AIzaSyC-ISzms6alSaudE3HfhWxXaevmPaR_KkY",
  authDomain: "dev-nenc-mentors.firebaseapp.com",
  databaseURL: "https://dev-nenc-mentors.firebaseio.com",
  projectId: "dev-nenc-mentors",
  storageBucket: "dev-nenc-mentors.appspot.com",
  messagingSenderId: "613925081572",
  appId: "1:613925081572:web:a9c244c8137c83e4bab7f1"
};

// change the config to initialise in the line below to match the project host to be used
// don't forget to execute firebase use [host alias] (see .firebaserc for list) to match before deploying 
firebase.initializeApp(seConfig)


var functions = firebase.functions()

//Date issue fix according to firebase
//const settings = {timestampsInSnapshots: true}
//firebase.firestore().settings(settings)

//switch session authorisation persistance on
firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
  .then(function() {
    // Existing and future Auth states are now persisted in the current
    // session only. Closing the window would clear any existing state even
    // if a user forgets to sign out.
  })
  .catch(function(error) {
    // Handle Errors here.
    console.log("Error setting Authorisation persistance to session only: ", error);
    var errorCode = error.code;
    var errorMessage = error.message;
  });

const unsubscribe = firebase.auth().onAuthStateChanged(currentUser => {
  new Vue({
    router,
    store,
    render: h => h(App),
    created () {
      if (currentUser) {
        if (!currentUser.emailVerified) {
          // send a verification email
          // [see https://stackoverflow.com/questions/48998161/email-verification-for-firebase-auth-ui]
          currentUser.sendEmailVerification()
          .then(() => {
            // route the user to the verification email screen
            this.$router.push('/verify')
            /*
            // log the user out and return them to the login screen
            firebase.auth().signOut()
            .then(() => {
              this.$router.push('/verification')
            })
            */
          })
          .catch((error) => {
            console.log('Verification email error - ',error)

          })
        } else {
          //update the store with user details
          store.dispatch('autoSignIn', {email: currentUser.email, name: currentUser.displayName, uid: currentUser.uid})
          console.log("Main user: " + currentUser.email + '-' + currentUser.displayName)
          this.$router.push('/home')
        }
      }else {
        this.$router.push('/login')
      }
    }
  }).$mount('#app')
  unsubscribe()
})

/*
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
*/
